import { Injectable } from '@angular/core';
import { ReportCoreBaseService } from './base/report-core-base.service';

/** Il servizio ReportCoreService implementa le logiche client ed espone tutti i metodi del ReportCoreBaseService
 * che mappa il controller REST ReportCore 1:1.
 * */
@Injectable({
    providedIn: 'root',
})
export class ReportCoreService extends ReportCoreBaseService {
    constructor() {
        super();
    }
}
